// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Label_label__6QwFD {
  display: inline-flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
  padding-bottom: 4px;
  position: relative;
  white-space: nowrap;
  width: 100%;
}

.Label_text__v-xHv {
  max-width: 100%;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.Label_textWithStar__5PDCh {
  max-width: calc(100% - 8px);
}

.Label_star__zcCWX {
  text-align: right;
  width: 8px;
  color: #E23834;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/typography/Label/Label.module.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,mBAAA;EACA,kBAAA;EACA,mBAAA;EAMA,WAAA;AAPF;;AAUA;EACE,eAAA;EAMA,qBAAA;EAEA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAbF;AAKE;EACE,2BAAA;AAHJ;;AAaA;EACE,iBAAA;EACA,UApCW;EAqCX,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AAVF","sourcesContent":["$star-width: 8px;\n\n.label {\n  display: inline-flex;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #272A36;\n\n  padding-bottom: 4px;\n  position: relative;\n  white-space: nowrap;\n\n  //text-overflow: ellipsis;\n  //white-space: nowrap;\n  //overflow: hidden;\n\n  width: 100%;\n}\n\n.text {\n  max-width: 100%;\n\n  &WithStar {\n    max-width: calc(100% - #{$star-width});\n  }\n\n  display: inline-block;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.star {\n  text-align: right;\n  width: $star-width;\n  color: #E23834;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  user-select: none;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `Label_label__6QwFD`,
	"text": `Label_text__v-xHv`,
	"textWithStar": `Label_textWithStar__5PDCh`,
	"star": `Label_star__zcCWX`
};
export default ___CSS_LOADER_EXPORT___;
